// extracted by mini-css-extract-plugin
export default {"bgimg":"style_bgimg__bxbek","flex_slide":"style_flex_slide__CRO82","custompage":"style_custompage__GnZ-w","slickslide":"style_slickslide__BaRix","div_slide":"style_div_slide__yy08a"};